<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="mt-6">
        <v-card elevation="6">
          <div class="grid_col_img pa-4">
            <div class="pa-6">
              <v-img
                :lazy-src="picture_holder"
                :src="get_Details.picture"
                max-height="250"
                height="250"
                max-width="300"
                width="300"
                class="rounded mx-auto"
              ></v-img>
            </div>
            <div class="grid_full">
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <div class="ml-1" style="font-size: 26px">ข้อมูลสินค้า</div>
                  </div>
                </div>
                <div></div>
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-</v-icon>
                    <div class="ml-1"><b>รหัสสินค้า</b></div>
                  </div>
                  <div
                    v-if="
                      get_Details.product_code !== null &&
                      get_Details.product_code !== 'null'
                    "
                  >
                    {{ get_Details.product_code }}
                  </div>
                  <div v-else>-</div>
                </div>
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-</v-icon>
                    <div class="ml-1"><b>ประเภท</b></div>
                  </div>
                  <div
                    v-if="
                      get_Details.product_type_name !== null &&
                      get_Details.product_type_name !== 'null'
                    "
                  >
                    {{ get_Details.product_type_name }}
                  </div>
                  <div v-else>-</div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-</v-icon>
                    <div class="ml-1"><b>ชื่อสินค้า</b></div>
                  </div>
                  <div
                    v-if="
                      get_Details.name !== null && get_Details.name !== 'null'
                    "
                  >
                    {{ get_Details.name }}
                  </div>
                  <div v-else>-</div>
                </div>
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-</v-icon>
                    <div class="ml-1"><b>ชื่อทางการแพทย์</b></div>
                  </div>
                  <div
                    v-if="
                      get_Details.name_sci !== null &&
                      get_Details.name_sci !== 'null'
                    "
                  >
                    {{ get_Details.name_sci }}
                  </div>
                  <div v-else>-</div>
                </div>
              </div>
              <div class="mr-1">
                <div class="d-flex">
                  <v-icon>mdi-</v-icon>
                  <div class="ml-1"><b>รายละเอียด</b></div>
                </div>
                <div
                  v-if="
                    get_Details.detail !== null && get_Details.detail !== 'null'
                  "
                >
                  {{ get_Details.detail }}
                </div>
                <div v-else>-</div>
              </div>
            </div>
          </div>
        </v-card>
        <div class="mt-6">
          <v-card elevation="6">
            <div class="pa-4">
              <span style="font-size: 24px">ตารางคำนวนเรทราคา</span>
            </div>
            <div class="pa-4">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  color="#8cc63e"
                  append-icon="mdi-magnify"
                  label="ค้นหา"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="productHeaders"
                :items="setProductPrice"
                :search="search"
                mobile-breakpoint="0"
                hide-default-footer
              >
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.u_name }}</td>
                    <td>
                      <div v-if="dataDetail.item.retail_price !== null">
                        {{ format_price(dataDetail.item.retail_price_show) }}
                      </div>
                      <div v-else>0.00</div>
                    </td>
                    <!-- percent / 100 x cost -->
                    <td>{{ format_price(dataDetail.item.rate_3) }}</td>
                    <td>{{ format_price(dataDetail.item.rate_5) }}</td>
                    <td>{{ format_price(dataDetail.item.rate_10) }}</td>
                    <td>{{ format_price(dataDetail.item.rate_20) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
        <!-- Initial_Sales -->
        <SetInitial_Sales @submitSetInitial="getSetInitial" />
        <!-- Special Price -->
        <Special_Price @submitSpecialPrice="getSpecialPrice" />
        <!-- Condition -->
        <Special_Condition @submitSpecialCondition="getSpecialCondition" />
      </div>
      <div class="text-center mt-6 mb-4">
        <v-btn
          height="50"
          @click="savePrice()"
          class="white--text grad-success-bg btn_mobile"
          >บันทึกข้อมูล</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import SetInitial_Sales from "./SetInitial_Sales";
import Special_Price from "./Special_Price";
import Special_Condition from "./Special_Condition";
import { HTTP } from "@/axios.js";
import picture_holder from "@/assets/picture.png";
import { formatPrice } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Product_MakePrice",
  components: {
    Special_Condition,
    Special_Price,
    SetInitial_Sales,
  },
  data() {
    return {
      loading_page: false,
      search: null,
      name: null,
      product_type: null,
      picture_holder: picture_holder,
      productHeaders: [
        {
          text: "หน่วยนับ",
          value: "product_name",
          fixed: true,
          width: "160px",
        },
        {
          text: "ราคาทุน(ต่อหน่วย)",
          value: "cost",
          fixed: true,
          width: "200px",
        },
        {
          text: "3%",
          value: "percent_3",
          fixed: true,
          width: "150px",
        },
        {
          text: "5%",
          value: "percent_5",
          fixed: true,
          width: "150px",
        },
        {
          text: "10%",
          value: "percent_10",
          fixed: true,
          width: "150px",
        },
        {
          text: "20%",
          value: "percent_20",
          fixed: true,
          width: "150px",
        },
      ],
      setProductPrice: [],
      makeHeader: [
        {
          text: "",
          value: "product_name",
          fixed: true,
          width: "140px",
        },
        {
          text: "ราคาขายปลีก",
          value: "",
          fixed: true,
          width: "160px",
        },
        {
          text: "ราคาขายส่ง(สด)",
          value: "",
          fixed: true,
          width: "160px",
        },
        {
          text: "ราคาขายส่ง(เครดิต)",
          value: "",
          fixed: true,
          width: "160px",
        },
      ],
      makeList: [
        {
          id: 1,
          product_name: "กล่อง 10 แพ็ค",
        },
        {
          id: 2,
          product_name: "แพ็ค 6 ซอง",
        },
        {
          id: 3,
          product_name: "ซอง",
        },
      ],
      typeItems: [
        { id: 1, name: "กล่อง" },
        { id: 2, name: "แพ็ค" },
        { id: 3, name: "แผง" },
        { id: 4, name: "เม็ด" },
      ],
      get_Details: [],
      unit_type: null,
      formatMakePrice: {
        product_id: "",
        product_set_price: [],
        set_codition_customer: [],
        set_condition_max: [],
      },
      alert_success: false,
    };
  },
  methods: {
    format_price: function (value) {
      return formatPrice(value);
    },
    cache_page() {
      window.addEventListener("beforeunload", function (event) {
        event.preventDefault();
        event.returnValue = "";
      });
    },
    getDetails() {
      const id = this.$route.params.id;
      this.formatMakePrice.product_id = id;
      this.loading_page = true;
      HTTP.post("/products/product/show/" + id).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false;
          this.get_Details = res.data.product;
        }
      });
    },
    getProduct_type() {
      HTTP.post("/products/producttype/all").then((res) => {
        if (res.data.success === true) {
          const in_select = res.data.object.find((details) => {
            return details.id == this.get_Details.product_type;
          });
          this.product_type = in_select;
          // console.log(this.product_type)
        }
      });
    },
    getProduct_list() {
      const id = this.$route.params.id;
      HTTP.post("/products/productlist/show/" + id).then((res) => {
        if (res.data.success === true) {
          this.setProductPrice = res.data.set_product_price;
        }
      });
    },
    getSetInitial(data) {
      this.formatMakePrice.product_set_price.push(data);
    },
    getSpecialPrice(data) {
      console.log(data);
      
      data = data.map((item) => {
        return {
          ...item,
          is_delete: item.is_delete == 1 ? item.is_delete : undefined,
          set_condition_list: item.condition_lists.map((condition) => ({
            ...condition,
            product_id: item.product_id,
          })),
          condition_lists: undefined,
        };
      });
      this.formatMakePrice.set_codition_customer = data;
    },
    getSpecialCondition(data) {
      data = data.map((item) => {
        return {
          ...item,
          is_delete: item.is_delete == 1 ? item.is_delete : undefined,
        };
      });
      this.formatMakePrice.set_condition_max = data;
    },
    savePrice() {
      console.log("formatMakePrice", this.formatMakePrice);

      HTTP.post("/products/product/update-price", this.formatMakePrice).then(
        (res) => {
          if (res.data.success === true) {
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 2000);
          }
        }
      );
    },
  },
  beforeMount() {
    this.getDetails();
  },
  mounted() {
    this.getProduct_type();
    this.getProduct_list();
  },
  created() {
    this.cache_page();
  },
};
</script>

<style scoped>
.grid_col_img {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1300px) {
  .grid_col_img {
    display: grid;
    grid-template-columns: 40% 60%;
  }
}
@media only screen and (max-width: 1180px) {
  .grid_col_img {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 600px) {
  .grid_col_img {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
